"use strict";

exports.__esModule = true;
exports.viewLogs = exports.viewChanges = exports.unableToBuildPreview = exports.shareFeedback = exports.previewUpdated = exports.pageHasBeenUpdated = exports.linkCopied = exports.kickingOffBuild = exports.howAreWeDoing = exports.deploying = exports.copyLink = exports.buildingPreview = exports.buildingNewPreview = void 0;
var _dateFns = require("date-fns");
const viewChanges = `View changes`;
exports.viewChanges = viewChanges;
const pageHasBeenUpdated = `This page has been updated.`;
exports.pageHasBeenUpdated = pageHasBeenUpdated;
const viewLogs = `View logs`;
exports.viewLogs = viewLogs;
const buildingNewPreview = `Building a new preview`;
exports.buildingNewPreview = buildingNewPreview;
const deploying = `Deploying...`;
exports.deploying = deploying;
const kickingOffBuild = `Kicking off your build...`;
exports.kickingOffBuild = kickingOffBuild;
const buildingPreview = `Building your preview...`;
exports.buildingPreview = buildingPreview;
const previewUpdated = date => `Preview updated ${(0, _dateFns.formatDistance)(Date.now(), date, {
  includeSeconds: true
})} ago`;
exports.previewUpdated = previewUpdated;
const unableToBuildPreview = `Unable to build preview`;
exports.unableToBuildPreview = unableToBuildPreview;
const howAreWeDoing = `How are we doing?`;
exports.howAreWeDoing = howAreWeDoing;
const shareFeedback = `Share feedback`;
exports.shareFeedback = shareFeedback;
const linkCopied = `Link copied`;
exports.linkCopied = linkCopied;
const copyLink = `Copy link`;
exports.copyLink = copyLink;